var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlickr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 300",
    style: {
      enableBackground: "new 0 0 300 300"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#CCCCCC;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons_5_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Black_5_",
    transform: "translate(-504.000000, -516.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Line-4_1_",
    transform: "translate(200.000000, 500.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Flickr_1_",
    className: "st0",
    d: "M562.4,166c0,26.1-21.4,47.3-47.7,47.3 c-26.4,0-47.8-21.2-47.8-47.3c0-26.1,21.4-47.2,47.8-47.2C541.1,118.7,562.4,139.9,562.4,166z M441.1,166 c0,26.1-21.4,47.3-47.8,47.3c-26.4,0-47.7-21.2-47.7-47.3c0-26.1,21.4-47.2,47.7-47.2C419.7,118.7,441.1,139.9,441.1,166z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlickr);
export default __webpack_public_path__ + "static/media/flickr.8a36c89b58aff9a1c5bcdfd2ff9f98cb.svg";
export { ForwardRef as ReactComponent };